{
  "chromeIds": {
    "stable": "nkbihfbeogaeaoehlefnkodbefgpgknn",
    "beta": "pbbkamfgmaedccnfkmjcofcecjhfgldn",
    "flask": "ljfoeinjpaedjfecbmggjgodbgkmjkjk"
  },
  "firefoxIds": {
    "stable": "webextension@metamask.io",
    "beta": "webextension-beta@metamask.io",
    "flask": "webextension-flask@metamask.io"
  }
}
